import { SET_UI_LOADING } from '../actions/actionTypes';

export const uiLoaderReducer = (state = false, action: { type: string; isLoading: boolean; }) => {
  switch (action.type) {
    case SET_UI_LOADING:
      return action.isLoading;
    default: return state;
  }
};